module.exports = __webpack_public_path__ + "img/mango-1.b9651be1.png";